import { ControlPosition, Map } from 'shared/map-exports';

import { useTranslation } from 'react-i18next';
import { isIframe } from 'shared/utils';
import { MapViewDimension } from 'features/mapping/mapping.constants';
import { useMapGLController } from 'features/mapping/hooks/useMapGLController/useMapGLController';
import { MapControlButton, useButtonGroupStyles } from '../MapControlButton';
import {
  BaseMapboxGLController,
  BaseMapboxGLControllerProps,
  ThemeMode,
} from '../BaseMapboxGLController';
import { trackMapDimensionChangeToPosthog } from '../../../mapping.utils';

type MapViewDimensionControlProps = {
  position?: ControlPosition;
  setMapViewDimension: (viewDimension: MapViewDimension) => void;
  mapViewDimension: MapViewDimension;
  forcedThemeMode?: ThemeMode;
};

const MapViewDimensionControlContent = (
  props: MapViewDimensionControlProps,
): JSX.Element => {
  const { t } = useTranslation();

  const { mapViewDimension, setMapViewDimension } = props;

  const handleToggleBaseMapViewDimension = (): void => {
    const dimension =
      mapViewDimension === MapViewDimension['3D']
        ? MapViewDimension['2D']
        : MapViewDimension['3D'];

    setMapViewDimension(dimension);
    trackMapDimensionChangeToPosthog(dimension);
  };

  const buttonText =
    mapViewDimension === MapViewDimension['3D']
      ? t('map.layers.dimensions.2D')
      : t('map.layers.dimensions.3D');

  const { classes } = useButtonGroupStyles();
  return (
    <MapControlButton
      onClick={() => handleToggleBaseMapViewDimension()}
      text={buttonText}
      className={isIframe() ? undefined : classes.groupBottomButton}
      size="small"
    />
  );
};

class MapboxGLMapTypeController extends BaseMapboxGLController<
  MapViewDimensionControlProps & BaseMapboxGLControllerProps & { map?: Map }
> {
  content = (): JSX.Element => (
    <MapViewDimensionControlContent map={this.map} {...this.props} />
  );
}

export const MapViewDimensionControl = (
  props: MapViewDimensionControlProps,
): null => {
  useMapGLController(props, MapboxGLMapTypeController);
  return null;
};
